import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

export const SowChangeSendAddendumTaskAttemptSchema = z.object({
  type: z.literal(TaskType.SOW_CHANGE_SEND_ADDENDUM),
  attemptType: z.literal("SEND"),
  // Required to send again once the addendum is out: a second SEND re-sends the homeowner a new PandaDoc.
  resend: z.boolean().optional(),
});
